// Registry of editable fields shown in Admin > Contenu > Textes & images.
// Empty value = original site content. Overrides apply immediately (DB-backed).

const PAGE_HEROES = [
  ["/depannage", "Dépannage"],
  ["/application", "Application"],
  ["/espaces", "Espaces"],
  ["/solutions", "Solutions"],
  ["/tarifs", "Tarifs"],
  ["/annonces", "Annonces"],
  ["/metiers", "Métiers"],
  ["/rejoindre", "Rejoindre"],
  ["/souscription", "Souscription"],
  ["/contact", "Contact"],
  ["/conseils", "Conseils"],
];

export const FIELD_GROUPS = [
  {
    group: "Général & coordonnées",
    fields: [
      { key: "site.prelaunch", label: "Bandeau jaune en haut du site", type: "text" },
      { key: "site.footer.description", label: "Pied de page — phrase de présentation", type: "textarea" },
      { key: "site.phone", label: "Téléphone affiché", type: "text" },
      { key: "site.email", label: "E-mail affiché", type: "text" },
      { key: "site.zone", label: "Zone d'intervention affichée", type: "text" },
    ],
  },
  {
    group: "Accueil — haut de page",
    fields: [
      { key: "home.hero.overline", label: "Sur-titre", type: "text" },
      { key: "home.hero.title", label: "Grand titre (une ligne par saut de ligne)", type: "textarea" },
      { key: "home.hero.subtitle", label: "Sous-titre", type: "textarea" },
      { key: "home.hero.image", label: "Image de fond (URL)", type: "image" },
      { key: "home.hero.stat1.value", label: "Encart chiffré — valeur 1 (ex : 2 h)", type: "text" },
      { key: "home.hero.stat1.text", label: "Encart chiffré — texte 1", type: "textarea" },
      { key: "home.hero.stat2.value", label: "Encart chiffré — valeur 2 (ex : 1 espace)", type: "text" },
      { key: "home.hero.stat2.text", label: "Encart chiffré — texte 2", type: "textarea" },
    ],
  },
  {
    group: "Accueil — sections",
    fields: [
      { key: "home.depannage.overline", label: "Dépannage 7j/7 — sur-titre", type: "text" },
      { key: "home.depannage.title", label: "Dépannage 7j/7 — titre", type: "textarea" },
      { key: "home.depannage.text", label: "Dépannage 7j/7 — texte", type: "textarea" },
      { key: "home.app.overline", label: "Section Application — sur-titre", type: "text" },
      { key: "home.app.title", label: "Section Application — titre", type: "textarea" },
      { key: "home.app.text", label: "Section Application — texte", type: "textarea" },
      { key: "home.manifesto.overline", label: "« Un nouveau réflexe » — sur-titre", type: "text" },
      { key: "home.manifesto.title", label: "« Un nouveau réflexe » — titre", type: "textarea" },
      { key: "home.ai.overline", label: "Innovation IA (Gaël, Jéthèque, Orion, Jarvis) — sur-titre", type: "text" },
      { key: "home.ai.title", label: "Innovation IA — titre", type: "textarea" },
      { key: "home.carnet.overline", label: "Carnet de Santé — sur-titre", type: "text" },
      { key: "home.carnet.title", label: "Carnet de Santé — titre", type: "textarea" },
      { key: "home.carnet.text", label: "Carnet de Santé — texte", type: "textarea" },
      { key: "home.carnet.image", label: "Carnet de Santé — image (URL)", type: "image" },
      { key: "home.etat.title", label: "État des lieux — titre", type: "textarea" },
      { key: "home.etat.text", label: "État des lieux — texte", type: "textarea" },
      { key: "home.personas.overline", label: "Espaces — sur-titre", type: "text" },
      { key: "home.personas.title", label: "Espaces — titre", type: "textarea" },
      { key: "home.why.overline", label: "Pourquoi choisir — sur-titre", type: "text" },
      { key: "home.why.title", label: "Pourquoi choisir — titre", type: "textarea" },
      { key: "home.cta.title", label: "Encart final — titre", type: "textarea" },
      { key: "home.cta.text", label: "Encart final — texte", type: "textarea" },
    ],
  },
  {
    group: "Accueil — La solution (3 cartes)",
    fields: [
      { key: "home.solution.overline", label: "Sur-titre", type: "text" },
      { key: "home.solution.title", label: "Titre", type: "textarea" },
      { key: "home.solution.text", label: "Texte d'introduction", type: "textarea" },
      { key: "home.solution.card1.title", label: "Carte 1 — titre", type: "text" },
      { key: "home.solution.card1.text", label: "Carte 1 — texte", type: "textarea" },
      { key: "home.solution.card2.title", label: "Carte 2 — titre", type: "text" },
      { key: "home.solution.card2.text", label: "Carte 2 — texte", type: "textarea" },
      { key: "home.solution.card3.title", label: "Carte 3 — titre", type: "text" },
      { key: "home.solution.card3.text", label: "Carte 3 — texte", type: "textarea" },
    ],
  },
  {
    group: "Accueil — Les 4 étapes",
    fields: [
      { key: "home.process.overline", label: "Sur-titre", type: "text" },
      { key: "home.process.title", label: "Titre", type: "textarea" },
      { key: "home.process.step1.title", label: "Étape 1 — titre", type: "text" },
      { key: "home.process.step1.text", label: "Étape 1 — texte", type: "textarea" },
      { key: "home.process.step2.title", label: "Étape 2 — titre", type: "text" },
      { key: "home.process.step2.text", label: "Étape 2 — texte", type: "textarea" },
      { key: "home.process.step3.title", label: "Étape 3 — titre", type: "text" },
      { key: "home.process.step3.text", label: "Étape 3 — texte", type: "textarea" },
      { key: "home.process.step4.title", label: "Étape 4 — titre", type: "text" },
      { key: "home.process.step4.text", label: "Étape 4 — texte", type: "textarea" },
    ],
  },
  {
    group: "Accueil — Chaque acteur (6 cartes)",
    fields: [
      { key: "home.acteurs.overline", label: "Sur-titre", type: "text" },
      { key: "home.acteurs.title", label: "Titre", type: "textarea" },
      ...[1, 2, 3, 4, 5, 6].flatMap((n) => [
        { key: `home.acteurs.card${n}.title`, label: `Carte ${n} — titre`, type: "text" },
        { key: `home.acteurs.card${n}.text`, label: `Carte ${n} — texte`, type: "textarea" },
      ]),
    ],
  },
  {
    group: "Accueil — Tableau comparatif",
    fields: [
      { key: "home.diff.overline", label: "Sur-titre", type: "text" },
      { key: "home.diff.title", label: "Titre", type: "textarea" },
      { key: "home.diff.head1", label: "Colonne gauche — en-tête", type: "text" },
      { key: "home.diff.head2", label: "Colonne droite — en-tête", type: "text" },
      ...[1, 2, 3, 4, 5].flatMap((n) => [
        { key: `home.diff.row${n}.problem`, label: `Ligne ${n} — problème`, type: "text" },
        { key: `home.diff.row${n}.answer`, label: `Ligne ${n} — réponse`, type: "textarea" },
      ]),
    ],
  },
  {
    group: "Hauts de page (toutes les pages)",
    fields: PAGE_HEROES.flatMap(([path, label]) => [
      { key: `${path}.hero.title`, label: `${label} — titre (une ligne par saut de ligne)`, type: "textarea" },
      { key: `${path}.hero.subtitle`, label: `${label} — sous-titre`, type: "textarea" },
      { key: `${path}.hero.image`, label: `${label} — image de fond (URL)`, type: "image" },
    ]),
  },
];
